<div *ngIf="isLoading">

    <app-on-hold-loading></app-on-hold-loading>

</div>


<div *ngIf="!isLoading">
    <app-header-core *ngIf="dataCompany != undefined" [dataCompany]="dataCompany"></app-header-core>

    <!-- FIN HEADER CONTENEDOR -->
    <!-- BODY CONTENEDOR -->
    <div class="container ecomm-bck" style="min-height: 770px;">
        <div class="main-wrap">
            <div class="ecomm-hd">
                <a class="backstep" style="cursor: pointer;" (click)="goBack()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                        [ngStyle]="{ 'color': colorPrimario }" class="bi bi-arrow-return-left" viewBox="0 0 16 16"
                        style="padding-right: 5px;">
                        <path fill-rule="evenodd"
                            d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5z" />
                    </svg> [Back to search results]</a>

                <!--<img src="{{logoCruise}}{{ storeLocalInquireService.getLogoBoat() }}" width="118" height="28" alt="Logo Boat"/>-->
                <strong *ngIf="storeLocalInquireService.getTextTempContPromotion() != 'Charter'">{{ textDaysCruise }}
                    Cruise
                    from
                    US${{ storeLocalInquireService.getPromoPrice() | number:'3.0-0' }} <span
                        *ngIf="storeLocalInquireService.getPromoPrice() != storeLocalInquireService.getRackPrice()">(<u
                            style="text-decoration: line-through">US${{ storeLocalInquireService.getRackPrice() |
                            number:'3.0-0'
                            }}</u>)</span> p/person</strong>
                <strong
                    *ngIf="storeLocalInquireService.getTextTempContPromotion() === 'Charter' && storeLocalInquireService.getPromotion().length > 0">{{
                    textDaysCruise }} Cruise from Charter Only US${{ storeLocalInquireService.getPromoPrice() |
                    number:'3.0-0'
                    }}
                    <span *ngIf="storeLocalInquireService.getPromoPrice() != storeLocalInquireService.getRackPrice()">
                        (<u style="text-decoration: line-through">US${{ storeLocalInquireService.getRackPrice() |
                            number:'3.0-0'
                            }}</u>)</span>
                </strong>
                <strong
                    *ngIf="storeLocalInquireService.getTextTempContPromotion() === 'Charter' && storeLocalInquireService.getPromotion().length == 0">{{
                    textDaysCruise }} Cruise from Charter Only US${{ storeLocalInquireService.getRackPrice() |
                    number:'3.0-0'
                    }}</strong>

                <br />
                <!--      {{ promocion }} + {{ textContPromotion }}*-->
                <!--      {{ storeLocalInquireService.getPromotion() }} {{ storeLocalInquireService.getContPromotion() }}-->
                <span *ngIf="textPromo !== 'none'">
                    <strong style="color: #800011;">
                        {{ storeLocalInquireService.getPromotion() }}
                    </strong>
                </span>
                <br *ngIf="cruise.availability[cruise.iterIndex].groupsOnly">
                <p *ngIf="cruise.availability[cruise.iterIndex].groupsOnly" style="color: #800011;">GROUPS ONLY</p>
                <br *ngIf="cruise.availability[cruise.iterIndex].charterOnly">
                <p *ngIf="cruise.availability[cruise.iterIndex].charterOnly" style="color: #800011;">CHARTER ONLY</p>
            </div>
            <div id="infopax">
                <aside>
                    <img src="{{logoCruise}}{{ storeLocalInquireService.getImageBoat() }}" width="361" height="180"
                        alt="logo cruise" />
                    <h4 class="tourdet" [ngStyle]="{ 'color': colorPrimario }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                            [ngStyle]="{ 'color': '#'+colorPrimario }" fill="currentColor"
                            class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                            <path
                                d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                        </svg> Tour Details <img src="{{logoCruise}}{{ cruise.logo }}"
                            style="width: 7rem; float: right;" alt="Logo Boat" />
                    </h4>
                    <table width="100%">
                        <tbody>
                            <tr>
                                <th colspan="2" scope="col">Travel Dates</th>
                            </tr>
                            <tr>
                                <td><strong>Start Date:</strong></td>
                                <!--              <td>{{ fechaArrivo }} *</td>-->
                                <td>{{ storeLocalInquireService.getStartDate() | date: 'MMM dd, yyyy' }} </td>
                            </tr>
                            <tr>
                                <td><strong>End Date:</strong></td>
                                <!--              <td>{{ fechaSalida }} *</td>-->
                                <td>{{ storeLocalInquireService.getEndDate() | date: 'MMM dd, yyyy' }} </td>
                            </tr>
                            <tr>
                                <th colspan="2" scope="col">Tour Details</th>
                            </tr>
                            <tr>
                                <td><strong>Itinerary ({{ this.storeLocalInquireService.getNameIti()?.substr(1,
                                        1)}}):</strong></td>
                                <!--              <td>{{ textItinerary }} (<a href="#">more info</a>)</td>-->
                                <td>{{ textItinerary }}</td>
                            </tr>
                            <tr>
                                <td><span><strong>{{ storeLocalInquireService.getTextTempContPromotion() != 'Charter' ?
                                            'From:' :
                                            'Price:'
                                            }}</strong></span></td>
                                <td *ngIf="storeLocalInquireService.getTextTempContPromotion() != 'Charter'">US${{
                                    storeLocalInquireService.getPromoPrice() | number:'3.0-0' }} <span
                                        *ngIf="storeLocalInquireService.getPromoPrice() != storeLocalInquireService.getRackPrice()">
                                        (<u style="text-decoration: line-through">US${{
                                            storeLocalInquireService.getRackPrice() |
                                            number:'3.0-0'
                                            }}</u>)</span> p/person</td>
                                <td
                                    *ngIf="storeLocalInquireService.getTextTempContPromotion() === 'Charter' && storeLocalInquireService.getPromotion().length == 0">
                                    US${{ storeLocalInquireService.getRackPrice() | number:'3.0-0' }}</td>
                                <td
                                    *ngIf="storeLocalInquireService.getTextTempContPromotion() === 'Charter' && storeLocalInquireService.getPromotion().length > 0">
                                    US${{ storeLocalInquireService.getPromoPrice() | number:'3.0-0' }}
                                    <span
                                        *ngIf="storeLocalInquireService.getPromoPrice() != storeLocalInquireService.getRackPrice()">
                                        (<u style="text-decoration: line-through">US${{
                                            storeLocalInquireService.getRackPrice() |
                                            number:'3.0-0'
                                            }}</u>)</span>
                                </td>
                            </tr>
                            <tr *ngIf="textPromo !== 'none'">
                                <td><strong>Promotion:</strong></td>
                                <!--              <td>{{ storeLocalInquireService.getPromotion() }} {{ storeLocalInquireService.getContPromotion() }}</td>-->
                                <td style="color: #800011">
                                    <strong>
                                        {{storeLocalInquireService.getPromotion()}}
                                    </strong>
                                </td>
                            </tr>
                            <tr
                                *ngIf="cruise.availability[cruise.iterIndex].groupsOnly || cruise.availability[cruise.iterIndex].charterOnly">
                                <td>
                                    <strong>Remark:</strong>
                                </td>
                                <td style="color:#800011">
                                    <span *ngIf="cruise.availability[cruise.iterIndex].groupsOnly">
                                        GROUPS ONLY
                                    </span>
                                    <span *ngIf="cruise.availability[cruise.iterIndex].charterOnly">
                                        CHARTER ONLY
                                    </span>

                                </td>
                            </tr>
                            <tr *ngIf="storeLocalInquireService.getAditionalServices().length > 0">
                                <th colspan="2" scope="col">Aditional Services</th>
                            </tr>
                            <tr *ngFor="let serv of storeLocalInquireService.getAditionalServices()">
                                <td colspan="2">
                                    <small>&raquo; {{ serv }}</small>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <br />
                    <table width="100%" border="1" id="tShare">
                        <tbody>
                            <tr>
                                <td>
                                    <a class="shareDate" (click)="openDialogShare()">Share This Departure</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!--<ul>
            <li><strong>Promotion: </strong><span class="mod-content active">
              <label>{{ storeLocalInquireService.getPromotion() }}</label>
              </span>
            </li>
            <li>
              <strong>Itinerary:</strong> {{ textStarEndDay | uppercase }}
            </li>
          </ul>-->
                </aside>
                <div class="modules-ecomm">
                    <div *ngIf="!isOnHold">
                        <div class="headmod" [ngStyle]="{ 'background-color': colorPrimario }">Need More Information or
                            Ready to Make Your Reservation?
                        </div>

                        <form name="inquireForm" #f="ngForm" (ngSubmit)="f.form.valid && enviarFormulario(f)"
                            novalidate>
                            <div class="mod-content active">
                                <h1>{{WELCOME_TEXT}} {{cruise.name}}</h1>
                                <p>Please fill out the fields below:</p>
                                <br />
                                <h3>Number of Passengers</h3>
                                <div class="form-grp">
                                    <label>Adults:</label>
                                    <select #adults="ngModel" [(ngModel)]="registerForm.formAdultos" id="Number_Adults"
                                        name="adults" required>
                                        <option selected="selected" value="--">Please choose</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                        <option value="13">13</option>
                                        <option value="14">14</option>
                                        <option value="15">15</option>
                                        <option value="16">16</option>
                                    </select>
                                </div>
                                <div class="form-grp">
                                    <label>Children:</label>
                                    <select #children="ngModel" [(ngModel)]="registerForm.formNinos"
                                        id="Number_Children" name="children"
                                        [attr.disabled]="disableChildren ? true : null">
                                        <option selected="selected" value="0">0</option>
                                        <option value="0">None</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                    </select>
                                    <span>(under {{this.cruise.maximumAgeChild}} years old)</span>
                                </div>

                                <div *ngIf="registerForm.listInterest.length > 0">
                                    <hr class="dotted">
                                    <h3>I may also be interested in</h3>
                                    <div class="form-grp" *ngFor="let item of registerForm?.listInterest; let i=index">
                                        <label>
                                            <input #vuelos="ngModel" [(ngModel)]="registerForm.listInterest[i].status"
                                                id="Galapagos_Flights" name="vuelos" type="checkbox">
                                            {{item.description}}
                                        </label>
                                    </div>
                                </div>


                                <hr class="dotted">
                                <h3>Any Questions, Comments or Special Requests</h3>
                                <textarea class="comments" #comments="ngModel"
                                    [(ngModel)]="registerForm.formComentarios" cols="70" id="Questions_Comments"
                                    maxlength="1000" name="comments" rows="5" wrap="physical">
                </textarea>
                                <hr class="dotted">
                                <h3>Contact Information</h3>
                                <!-- ERRORS MESSAGES -->
                                <div class="pink-errors" id="personal-errors">
                                    <span id="errorcontactPerson"></span>
                                    <span id="erroremail"></span>
                                </div>
                                <!-- -->
                                <div class="form-grp">
                                    <label for="contactName">Contact person (*):</label>
                                    <input #contactName="ngModel" [(ngModel)]="registerForm.formContacto"
                                        class="form-control" id="contactName" name="contactName" type="text"
                                        [ngClass]="{ 'is-invalid': f.submitted && contactName.invalid }" required />
                                    <div *ngIf="f.submitted && contactName.invalid" class="invalid-feedback">
                                        <div *ngIf="contactName.errors.required">Field is required</div>
                                    </div>
                                </div>
                                <div class="form-grp">
                                    <label for="email">E-mail (*):</label>
                                    <input #email="ngModel" [(ngModel)]="registerForm.formCorreo" id="Email"
                                        maxlength="300" name="email"
                                        pattern="^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$"
                                        type="text" class="form-control"
                                        [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required email />
                                    <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                                        <div *ngIf="email.errors.required">Email is required</div>
                                        <div *ngIf="email.errors.email">Email must be a valid email address</div>
                                    </div>
                                </div>
                                <div class="form-grp" style="overflow: visible !important;">
                                    <label>Telephone (optional):</label>
                                    <!--<input #telephone="ngModel" [(ngModel)]="registerForm.formTelefono" id="Telephone"
                                        maxlength="15" name="telephone" class="form-control" type="text">-->
                                    <ngx-intl-tel-input [cssClass]="'custom'" class="form-control"
                                        [preferredCountries]="[CountryISO.UnitedStates, CountryISO.UnitedKingdom]"
                                        [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                                        [searchCountryFlag]="true" [(ngModel)]="registerForm.formItiObject"
                                        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                        [selectFirstCountry]="true" [selectedCountryISO]="CountryISO.UnitedStates"
                                        [maxLength]="15" [phoneValidation]="false" name="telephone" id="Telephone"
                                        [separateDialCode]="true"></ngx-intl-tel-input>
                                </div>
                                <!--<div class="form-grp">
                                    <label for="pais">Country (optional):</label>
                                    <select #pais="ngModel" [(ngModel)]="registerForm.formPais" id="pais" name="pais"
                                        class="form-control">
                                        <option [ngValue]="''">Please choose</option>
                                        <option *ngFor="let c of listCountries" value="{{ c.name }}">{{ c.name }}
                                        </option>
                                    </select>
                                    <div *ngIf="pais.invalid && f.submitted" class="invalid-feedback">
                                        <div *ngIf="pais.errors.required">Please Select Country.</div>
                                    </div>
                                </div>-->
                                <div class="form-grp">
                                    <label>Reference Name:</label>
                                    <input #referenceName="ngModel" [(ngModel)]="registerForm.formReferencia"
                                        id="referenceName" name="referenceName" type="text">
                                </div>
                                <div class="form-grp">
                                    <label>Agency Name (if applicable):</label>
                                    <input #agencyName="ngModel" [(ngModel)]="registerForm.formAgencia" id="agencyName"
                                        name="agencyName" type="text">
                                </div>

                                <div class="form-grp">
                                    <label for="howFindUs">How did you find us? (optional):</label>
                                    <select #howFindUs="ngModel" [(ngModel)]="registerForm.howFindUs" id="howFindUs"
                                        name="howFindUs" class="form-control">
                                        <option [ngValue]="''">Please choose</option>
                                        <option *ngFor="let c of howFindUsList" value="{{ c }}">{{ c }}</option>
                                    </select>

                                </div>
                                <div class="form-grp" *ngIf="registerForm.howFindUs==='Other'">
                                    <label>Other:</label>
                                    <input #other="ngModel" [(ngModel)]="registerForm.valueOther" id="other"
                                        name="other" type="text">
                                </div>

                                <div class="form-grp frm-row">
                                    <p>
                                        Mandatory fields (*):
                                    </p>
                                </div>

                                <div>
                                    <div class="form-grp frm-row">
                                        <label>
                                            <input #info="ngModel" [(ngModel)]="registerForm.formOferta" id="Send_Info"
                                                name="info" type="checkbox"> I am interested in receiving occasional
                                            promotions and offers from
                                            {{dataCompany?.name}}.</label>
                                    </div>
                                </div>

                                <div class="alert alert-danger" role="alert" *ngIf="f.submitted && !f.valid">
                                    Please review the preceding form to continue.
                                </div>
                                <input class="lngnext" style="cursor: pointer; border: none;" type="submit"
                                    [value]="showSending? 'Processing...':'Inquire Now'" *ngIf="showButtonSend"
                                    [ngStyle]="{ 'background-color': colorSecundario }"
                                    [ngClass]="showSending ? 'button-processing':''" />
                                <!--            <a href="thanks.html" class="lngnext">Send</a>-->
                                <div *ngIf="showSending"
                                    style="background: url('../../../assets/images/sending.gif') no-repeat center center; width: 100%; height: 128px;">
                                </div>
                                <p style="text-align: center; margin-top: 30px;">
                                    <em><strong _ngcontent-c1="">Important: </strong>Certain filters and security
                                        settings may prevent our
                                        emails (responses) from arriving in your inbox so please be sure to check your
                                        junk, trash or spam
                                        folders.</em>
                                </p>
                            </div>
                        </form>
                    </div>
                    <div *ngIf="isOnHold && dataCompany!==undefined && cruise">
                        <app-onhold [dataCompany]="dataCompany" [cruise]="cruise" [packageCode]="optionA"
                            [selectedItinerary]="cruise.iterIndex"></app-onhold>
                    </div>

                </div>
                <br>
            </div>
        </div>
    </div>
    <!-- FIN BODY CONTENEDOR -->
    <div id="footerInq">
        <!-- FOOTER CONTENEDOR -->
        <div class="container" *ngIf="this.dataCompany!=undefined " style="display: block"
            [ngStyle]="{ 'background-color': colorPie }">
            <!-- end main -->
            <!-- start post footer -->
            <div class="post-footer">
                <div class="wrap2 row" id="powered-footer">


                    <p style="color: #ececec;" [ngClass]="isTooDark(colorPie) ? 'darkMode' : 'lightMode'">Copyright {{
                        todayDate }} ©
                        <a href="https://galavail.com/" target="_blank"
                            [ngClass]="isTooDark(colorPie) ? 'darkMode' : 'lightMode'">Galavail.com</a> &nbsp;All Rights
                        Reserved. &nbsp;&bull;&nbsp;
                        <a [ngClass]="isTooDark(colorPie) ? 'darkMode' : 'lightMode'" [href]="mailTo">{{ dataCompany !=
                            undefined ?
                            dataCompany.infoEmail : '' }}</a>
                    </p>
                    <img src="assets/images/powered-by-galavail.svg" alt="powered-by" style="margin-bottom: 15px;" />
                </div>
            </div>
            <!-- end post footer -->
        </div>
    </div>
    <ng-template #loading>Loading...</ng-template>
    <app-whatsapp-button [whatsappNumber]="this.whatsappNumber"></app-whatsapp-button>